<template>
  <div class="text-center">
    <v-dialog v-model="shower" scrollable
        width="90%"
        hight="100%"
        v-if="($vuetify.breakpoint.lg || $vuetify.breakpoint.md || $vuetify.breakpoint.xl || $vuetify.breakpoint.xxl)">
    <v-card>
    <v-toolbar flat>
      <v-row>
        <v-col cols="8" md="8" sm="8" xs="8">
        <v-toolbar-title>{{$t("settingprofile.setting") }}</v-toolbar-title>
        </v-col>
        <v-col cols="3" md="3" sm="3" xs="3">
        </v-col>
        <v-col cols="1" md="1" sm="1" xs="1" class="text-center">
          <v-icon @click="shower = false">mdi-close-box</v-icon>
        </v-col>
      </v-row>
    </v-toolbar>
    <v-divider elevation="5"></v-divider>
    <v-tabs vertical elevation="5">
      <v-tab >
        <v-icon left>
          mdi-account-cog
        </v-icon>
        {{$t("settingprofile.profilesettings") }}
      </v-tab>
      <v-tab v-if="role === 'host'">
        <v-icon left>
          mdi-application-cog-outline
        </v-icon>
        {{$t("settingprofile.Meetingsettings") }}
      </v-tab>
      <v-tab-item>
        <v-card>
          <v-card-text class="text-center">
              <v-row>
                <v-col  cols="1" md="1" sm="1" xs="1"></v-col>
              <v-col  cols="4" md="4" sm="4" xs="4" class="mt-n4">
                <div>
                <v-avatar
                  class="profile"
                  prepend-icon="mdi-camera"
                  size="200"
                  style="cursor: pointer;"
                  @click="$refs.avatarInput.click()"
                >
                <v-img  :src="avatar" v-model="avatar" ></v-img>
                  <v-btn
                    absolute
                    block
                    class=" mt-16 pt-16 pb-3"
                    style="text-transform: none; background: rgba(233, 225, 225, 0.7)"
                  >
                    <input
                    type="file"
                    accept="image/*"
                    @change="onFileSelected"
                    style="font-size: 20pt; display: none;"
                    ref="avatarInput"
                    />
                    <span style="font-size: 15pt" class="mt-n12">{{$t("settingprofile.editprofile") }}
                      <v-icon size="35" class="mt-n3">mdi-lead-pencil</v-icon></span>
                  </v-btn>
                </v-avatar>
              </div>
              </v-col>
              <v-col  cols="7" md="7" sm="7" xs="7">
                <span class="text-left" style="font-size: 18px;">
                <p><span>{{$t("loginpage.name") }}: </span><span>{{this.user.name}} </span><span> {{this.user.lastname}}</span></p>
                <p><span>{{$t("loginpage.email") }}: </span><span>{{this.user.email}}</span></p>
                <p><span>{{$t("loginpage.Tel") }}: </span><span>{{this.user.phonenumber}} </span></p>
              </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="1" md="1" sm="1" xs="1"></v-col>
              <v-col cols="4" md="4" sm="4" xs="4">
                <v-btn @click="clickpicture" block class="mr-2">{{$t("settingprofile.btnprofilepick") }}</v-btn>
              </v-col>
              <v-col cols="4" md="4" sm="4" xs="4">
                <v-btn @click="removeprofile" block>{{$t("settingprofile.btndelprofile") }}</v-btn>
              </v-col>
              <v-col cols="1" md="1" sm="1" xs="1">
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card>
          <v-card-text class="text-center">
              <v-row>
                <v-col  cols="3" md="3" sm="3" xs="3"></v-col>
              <v-col  cols="5" md="5" sm="5" xs="5" class="mt-n4" @click="$refs.avatarlogoInput.click()" style="cursor: pointer;">
                <div align="center">
                <v-img :src="logo" v-model="logo" width="360" height="360">
                </v-img>
                   <v-btn
                    absolute
                    block
                    class="mt-n16 pb-16"
                    style="text-transform: none; background: rgba(233, 225, 225, 0.7)"
                  >
                    <input
                    type="file"
                    accept="image/*"
                    style="font-size: 20pt; display: none;"
                    @change="onFileSelectedlogo"
                    ref="avatarlogoInput"
                    />
                    <span style="font-size: 15pt" class="mt-16">{{$t("settinglogo.editlogo") }}
                      <v-icon size="30" class="mt-n4">mdi-lead-pencil</v-icon></span>
                  </v-btn>
              </div>
              </v-col>
              <!-- <v-col  cols="2" md="2" sm="2" xs="2">
              </v-col> -->
            </v-row>
            <v-row>
              <v-col cols="3" md="3" sm="3" xs="3">
              </v-col>
              <v-col cols="4" md="6" sm="4" xs="4" class="text-left">
                <span style="color: red;"> *{{$t("settinglogo.Introduce") }}</span>
              </v-col>
            </v-row>
            <v-row class="mt-n6">
              <v-col cols="3" md="3" sm="3" xs="3">
              </v-col>
              <v-col cols="4" md="6" sm="4" xs="4" class="text-left">
                <span style="color: red;"> *{{$t("settinglogo.pictruepng") }}</span>
              </v-col>
            </v-row>
            <v-row class="mt-n6">
              <v-col cols="3" md="3" sm="3" xs="3">
              </v-col>
              <v-col cols="4" md="6" sm="4" xs="4" class="text-left">
                <span style="color: red;"> *{{$t("settinglogo.sizelogo") }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="1" md="1" sm="1" xs="1">
            </v-col>
            <v-col cols="3" md="3" sm="3" xs="3" class="text-right mt-2">
              <span style="font-size: 20px;">
                {{$t("settinglogo.namecompany") }} :
              </span>
            </v-col>
              <v-col cols="4" md="4" sm="4" xs="4">
                <v-text-field
                    autofocus
                    outlined
                    v-model="namecompany"
                    :hint="$t('settinglogo.logoalready')"
                    placeholder="One Meet"
                    dense
                    style="font-size: 12px;"
                  ></v-text-field>
              </v-col>
              <v-col cols="1" md="1" sm="1" xs="1">
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="1" md="1" sm="1" xs="1"></v-col>
              <v-col cols="4" md="4" sm="4" xs="4">
                <v-btn  @click="clicklogo" block>{{$t("settinglogo.btnlogopick") }}</v-btn>
              </v-col>
              <v-col cols="4" md="4" sm="4" xs="4">
                <v-btn  @click="clickrestore" block>{{$t("button.restore") }}</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-card>
<!-- </template> -->
    <!-- </v-form> -->
      </v-dialog>
      <v-dialog
        v-model="shower" scrollable
        width="100%"
        hight="100%"
        v-if="($vuetify.breakpoint.sm || $vuetify.breakpoint.xs )">
      <!-- <v-form ref="form"> -->
        <v-card >
          <v-card-title>
            <v-row class="pt-4" no-gutters>
            <v-col cols="1" md="1" xs="1" sm="1"></v-col>
              <v-col cols="10" md="10" xs="10" sm="10">
                <span style="font-size: 28px; font-weight: 500; color: #353535;"> {{$t("settingprofile.setting") }} </span>
              </v-col>
              <v-col cols="1" md="1" sm="1" xs="1" class="text-center">
              <v-icon @click="shower = false">mdi-close-box</v-icon>
            </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-tabs background-color="rgba(0,0,0,0.1)" v-model="tabs" centered>
                <v-tab key="0"> <v-icon left>
                  mdi-account-cog
                </v-icon>
                {{$t("settingprofile.profilesettings") }}
              </v-tab>
                <v-tab key="1" v-if="role === 'host'">
                  <v-icon left>
                  mdi-application-cog-outline
                </v-icon>
                {{$t("settingprofile.Meetingsettings") }}
                </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
      <!-- Tab 1 -->
      <v-tab-item key="0" class="mt-4">
        <v-container grid-list-md class="text-center">
          <v-row>
                <!-- <v-col  cols="1" md="1" sm="1" xs="1"></v-col> -->
              <v-col  cols="12" md="12" sm="12" xs="12" class="mt-n4">
                <div>
                <v-avatar
                  class="profile"
                  prepend-icon="mdi-camera"
                  size="150"
                  style="cursor: pointer;"
                  @click="$refs.avatarInput.click()"
                >
                  <v-img  :src="avatar" v-model="avatar" ></v-img>
                  <v-btn
                    absolute
                    block
                    class=" mt-16 pt-10 pb-3"
                    style="text-transform: none; background: rgba(233, 225, 225, 0.7)"
                  >
                    <input
                    type="file"
                    accept="image/*"
                    @change="onFileSelected"
                    style="font-size: 20pt; display: none;"
                    ref="avatarInput"
                    />
                    <span style="font-size: 12pt" class="mt-n12">{{$t("settingprofile.editprofile") }}
                      <v-icon size="20" class="mt-n3">mdi-lead-pencil</v-icon></span>
                  </v-btn>
                </v-avatar>
              </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col  cols="2" md="4" sm="4" xs="4"></v-col>
              <v-col  cols="10" md="8" sm="8" xs="8">
                <span class="text-left" style="font-size: 12px;">
                <p><span>{{$t("loginpage.name") }}: </span><span>{{this.user.name}} </span><span> {{this.user.lastname}}</span></p>
                <p><span>{{$t("loginpage.email") }}: </span><span>{{this.user.email}}</span></p>
                <p><span>{{$t("loginpage.Tel") }}: </span><span>{{this.user.phonenumber}} </span></p>
              </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="1" md="1" sm="1" xs="1"></v-col>
              <v-col cols="10" md="10" sm="10" xs="10">
                <v-btn @click="clickpicture" block>{{$t("settingprofile.btnprofilepick") }}</v-btn>
              </v-col>
              <v-col cols="1" md="1" sm="1" xs="1">
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="1" md="1" sm="1" xs="1">
              </v-col>
              <v-col cols="10" md="10" sm="10" xs="10">
                <v-btn @click="removeprofile" block>{{$t("settingprofile.btndelprofile") }}</v-btn>
              </v-col>
              <v-col cols="1" md="1" sm="1" xs="1">
              </v-col>
            </v-row>
        </v-container>
      </v-tab-item>
      <!-- Tab 2 -->
      <v-tab-item key="1" class="mt-4">
        <v-row>
                <v-col  cols="1" md="4" sm="3" xs="3"></v-col>
              <v-col  cols="9" md="4" sm="4" xs="4" class="mt-n4" @click="$refs.avatarlogoInput.click()" style="cursor: pointer;">
                <div>
                <v-img width="100%" height="100%" :src="logo" v-model="logo">
                </v-img>
                   <v-btn
                    absolute
                    block
                    class="mt-n16 pb-16"
                    style="text-transform: none; background: rgba(233, 225, 225, 0.7)"
                  >
                    <input
                    type="file"
                    accept="image/*"
                    style="font-size: 20pt; display: none;"
                    @change="onFileSelectedlogo"
                    ref="avatarlogoInput"
                    />
                    <span style="font-size: 15pt" class="mt-16">{{$t("settinglogo.editlogo") }}
                      <v-icon size="30" class="mt-n4">mdi-lead-pencil</v-icon></span>
                  </v-btn>
              </div>
              </v-col>
              <v-col  cols="1" md="2" sm="2" xs="2">
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="1" md="4" sm="3" xs="3">
              </v-col>
              <v-col cols="10" md="6" sm="4" xs="4" class="text-left">
                <span style="color: red;"> *{{$t("settinglogo.Introduce") }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="1" md="4" sm="3" xs="3">
              </v-col>
              <v-col cols="10" md="6" sm="4" xs="4" class="text-left">
                <span style="color: red;"> *{{$t("settinglogo.pictruepng") }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="1" md="1" sm="1" xs="1">
            </v-col>
            <v-col cols="12" md="3" sm="2" xs="2" class=" mt-2">
              <span style="font-size: 20px;">
                {{$t("settinglogo.namecompany") }} 
              </span>
            </v-col>
              <v-col cols="12" md="6" sm="4" xs="4">
                <v-text-field
                    autofocus
                    outlined
                    v-model="namecompany"
                    :hint="$t('settinglogo.logoalready')"
                    placeholder="One Meet"
                    dense
                    style="font-size: 12px;"
                  ></v-text-field>
              </v-col>
              <!-- <v-col cols="1" md="1" sm="1" xs="1">
              </v-col> -->
            </v-row>
            <v-row>
              <v-col cols="0" md="3" sm="2" xs="3"></v-col>
              <v-col cols="12" md="4" sm="3" xs="4">
                <v-btn block @click="clicklogo">{{$t("settinglogo.btnlogopick") }}</v-btn>
              </v-col>
              <v-col cols="12" md="4" sm="3" xs="4">
                <v-btn block @click="clickrestore">{{$t("button.restore") }}</v-btn>
              </v-col>
            </v-row>
      </v-tab-item>
    </v-tabs-items>
          </v-card-text>
          <v-card-actions>
          </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: ["show"],
  data() {
    return {
      jwt: require("jsonwebtoken"),
      selectedFile: null,
      avatar: '',
      logo: '',
      namecompany:'',
      picture:'',
      picturelogo:'',
      tabs:null,
      userData: '',
      user:'',
      role: "",
      user_id: '',
      typepick: ''
    }
  },
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },
  watch: {
    shower(vale){
      this.decodejwttoken()
    }
  },
  methods: {
    ...mapActions("dialog", [""]),

    decodejwttoken() {
      var token = localStorage.getItem('user-token')
      const decryptedText = this.CryptoJS.AES.decrypt(
        token,
        process.env.VUE_APP_SECRET_KEY
      )
        .toString(this.CryptoJS.enc.Utf8)
        .replace(/"/g, '')
      var data = this.jwt.decode(decryptedText)
      this.userData = data
      this.user = this.userData.user
      this.user_id = this.userData.user._id
      if (this.userData.room !== null) {
        this.role = "host";
      } else {
        this.role = "guest";
      }
      this.getprofile()
    },
    onFileSelected(event) {
      this.selectedFile = event.target.files[0]
      const file = event.target.files[0]
      const filesize = file.size
      // console.log('file', file)
      if( filesize >= '75000') {
        this.$swal('ไฟล์รูปมีขนาดใหญ่เกินไป','ขนาดต้องไม่เกิน 75.0KB', 'warning')
      } else {
        this.avatar = URL.createObjectURL(file)
        const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
      }).then(res => {
        this.picture = res
        // console.log('picture', this.picture)
      }
      )
      var a = toBase64(file)
      }
    },
    onFileSelectedlogo(event) {
      this.selectedFile = event.target.files[0]
      const file = event.target.files[0]
      const filesize = file.size
      // console.log('file', file.size)
      if( filesize >= '75000') {
        this.$swal('ไฟล์รูปมีขนาดใหญ่เกินไป','ขนาดต้องไม่เกิน 75.0KB', 'warning')
      } else {
        this.logo = URL.createObjectURL(file)
        const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
      }).then(res => {
        this.picturelogo = res
        // console.log('picturelogo', this.picturelogo)
      }
      )
      var a = toBase64(file)
      }
    },
    clickrestore() {
      this.$swal.fire({
            title: this.$t("settinglogo.restorelogo"),
            text: this.$t("settinglogo.messageeditlogo"),
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: this.$t("button.btnok"),
            cancelButtonColor: '#d33',
            cancelButtonText: this.$t("button.btncancel"),
            allowOutsideClick: true
          }).then(res => {
            if (res.isConfirmed === true) {
              this.axios.put(process.env.VUE_APP_API + '/api/v1/theme/update', {
                  user_id: this.user_id,
                  // profile: "profile:1111",
                  meetingLock: true, 
                  SecretRoom: true, 
                  Login: true, 
                  logo: "",
                  company_name: "One Meet"
          }).then(res => {
            // console.log('clickpicture', res)
            this.$swal(this.$t("settinglogo.restorelogo"),'', 'success')
            // this.setgetProfile(true)
            this.shower = false
            window.open('/manage', '_self')
          }).catch(err => {
            // console.log('err clickpicture', err)
          })
            }
          })

    },
    clicklogo() {
      if (this.namecompany !== '') {
        if(this.picturelogo === ''|| this.picturelogo === null){
            this.$swal.fire({
            title: this.$t("settinglogo.editlogo"),
            text: this.$t("settinglogo.messageeditlogo"),
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: this.$t("button.btnok"),
            cancelButtonColor: '#d33',
            cancelButtonText: this.$t("button.btncancel"),
            allowOutsideClick: true
          }).then(res => {
            if (res.isConfirmed === true) {
              this.axios.put(process.env.VUE_APP_API + '/api/v1/theme/update', {
                  user_id: this.user_id,
                  // profile: "profile:1111",
                  meetingLock: true, 
                  SecretRoom: true, 
                  Login: true, 
                  logo: this.logo,
                  company_name: this.namecompany
          }).then(res => {
            // console.log('clickpicture', res)
            this.$swal(this.$t("settinglogo.btnlogopick"),'', 'success')
            // this.setgetProfile(true)
            this.shower = false
            window.open('/manage', '_self')
          }).catch(err => {
            // console.log('err clickpicture', err)
          })
            }
          })
          } else {
            this.$swal.fire({
            title: this.$t("settinglogo.editlogo"),
            text: this.$t("settinglogo.messageeditlogo"),
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: this.$t("button.btnok"),
            cancelButtonColor: '#d33',
            cancelButtonText: this.$t("button.btncancel"),
            allowOutsideClick: true
          }).then(res => {
            if (res.isConfirmed === true) {
              this.axios.put(process.env.VUE_APP_API + '/api/v1/theme/update', {
                  user_id: this.user_id,
                  // profile: "profile:1111",
                  meetingLock: true, 
                  SecretRoom: true, 
                  Login: true, 
                  logo: this.picturelogo,
                  company_name: this.namecompany
          }).then(res => {
            // console.log('clickpicture', res)
            this.$swal(this.$t("settinglogo.btnlogopick"),'', 'success')
            // this.setgetProfile(true)
            this.shower = false
            window.open('/manage', '_self')
          }).catch(err => {
            // console.log('err clickpicture', err)
          })
            }
          })
          }
      } else {
        if(this.picturelogo === ''|| this.picturelogo === null){
            this.$swal.fire({
            title: this.$t("settinglogo.editlogo"),
            text: this.$t("settinglogo.messageeditlogo"),
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: this.$t("button.btnok"),
            cancelButtonColor: '#d33',
            cancelButtonText: this.$t("button.btncancel"),
            allowOutsideClick: true
          }).then(res => {
            if (res.isConfirmed === true) {
              this.axios.put(process.env.VUE_APP_API + '/api/v1/theme/update', {
                  user_id: this.user_id,
                  // profile: "profile:1111",
                  meetingLock: true, 
                  SecretRoom: true, 
                  Login: true, 
                  logo: this.logo,
                  company_name: this.namecompany
          }).then(res => {
            // console.log('clickpicture', res)
            this.$swal(this.$t("settinglogo.btnlogopick"),'', 'success')
            // this.setgetProfile(true)
            this.shower = false
            window.open('/manage', '_self')
          }).catch(err => {
            // console.log('err clickpicture', err)
          })
            }
          })
          } else {
            this.$swal.fire({
            title: this.$t("settinglogo.editlogo"),
            text: this.$t("settinglogo.messageeditlogo"),
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: this.$t("button.btnok"),
            cancelButtonColor: '#d33',
            cancelButtonText: this.$t("button.btncancel"),
            allowOutsideClick: true
          }).then(res => {
            if (res.isConfirmed === true) {
              this.axios.put(process.env.VUE_APP_API + '/api/v1/theme/update', {
                  user_id: this.user_id,
                  // profile: "profile:1111",
                  meetingLock: true, 
                  SecretRoom: true, 
                  Login: true, 
                  logo: this.picturelogo,
                  company_name: this.namecompany
          }).then(res => {
            // console.log('clickpicture', res)
            this.$swal(this.$t("settinglogo.btnlogopick"),'', 'success')
            // this.setgetProfile(true)
            this.shower = false
            window.open('/manage', '_self')
          }).catch(err => {
            // console.log('err clickpicture', err)
          })
            }
          })
          }
      }
    },
    clickpicture() {
      if (this.picture === '' || this.picture === null) {
        this.$swal(this.$t("settingprofile.messprofile"),'', 'warning')
      } else {
        this.$swal.fire({
        title: this.$t("settingprofile.editprofile"),
        text: this.$t("settingprofile.messageedit"),
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: this.$t("button.btnok"),
        cancelButtonColor: '#d33',
        cancelButtonText: this.$t("button.btncancel"),
        allowOutsideClick: true
      }).then(res => {
        if (res.isConfirmed === true) {
           this.axios.post(process.env.VUE_APP_API + '/api/v1/theme/profile/', {
        user_id: this.user_id,
        profile: this.picture
      }).then(res => {
        // console.log('clickpicture', res)
        this.$swal(this.$t("settingprofile.btnprofilepick"),'', 'success')
        // this.setgetProfile(true)
        this.shower = false
        window.open('/manage', '_self')
      }).catch(err => {
        // console.log('err clickpicture', err)
      })
        }
      })
      }
    },
    removeprofile() {
        this.$swal.fire({
        title: this.$t("settingprofile.btndelprofile"),
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: this.$t("button.btnok"),
        cancelButtonColor: '#d33',
        cancelButtonText: this.$t("button.btncancel"),
        allowOutsideClick: true
      }).then(res => {
        if (res.isConfirmed === true) {
           this.axios.post(process.env.VUE_APP_API + '/api/v1/theme/profile/', {
        user_id: this.user_id,
        profile: ''
      }).then(res => {
        // console.log('clickpicture', res)
        this.$swal(this.$t("settingprofile.btndelprofile"),'', 'success')
        // this.setgetProfile(true)
        this.shower = false
        window.open('/manage', '_self')
      }).catch(err => {
        // console.log('err clickpicture', err)
      })
        }
      })
    },
    getprofile() {
      this.axios.get(process.env.VUE_APP_API + '/api/v1/theme/get/' +  this.user_id).then(res => {
        // console.log('res', res.data.data)
        this.logo = res.data.data.room.logo
        // this.avatar = res.data.data.user.profile
        this.namecompany = res.data.data.room.name
        this.avatar = res.data.data.user.profile
        // console.log('user_profile', this.avatar)
      }).catch(err => {
        console.log('err getprofile', err)
      })
    },
  }
};
</script>
<style scoped>

</style>
